import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { EVENT_TYPES } from 'client/site-modules/financing/constants/financing';

export class PreQualifyCheckUI extends Component {
  static propTypes = {
    financingResponse: PropTypes.shape({}).isRequired,
  };

  // eslint-disable-next-line no-restricted-syntax
  static get origin() {
    const { location } = window;

    /* istanbul ignore else */
    if (location.origin) {
      return window.location.origin;
    }

    /* istanbul ignore next */
    return `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}`;
  }

  componentDidMount() {
    const { financingResponse } = this.props;

    /* istanbul ignore else */
    if (parent) {
      parent.postMessage(
        {
          type: EVENT_TYPES.FINANCING_CHECK,
          data: JSON.stringify({
            financingResponse,
          }),
        },
        PreQualifyCheckUI.origin
      );
    }
  }

  render() {
    return null;
  }
}

export const mapStateToProps = state => ({
  financingResponse: state.financing.financingResponse,
});

export const PreQualifyCheck = connect(mapStateToProps)(PreQualifyCheckUI);
